import React, { useContext } from "react";
import commonContext from "../../../../common/context/common";

function SanctionCharges() {
    const { utils, lead } = useContext(commonContext);
    return (
        <>
            <div className="relative w-full">
                <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                    <li className="mb-2 lg:mb-0">
                        <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                            Processing Fee Amount (Non Refundable)
                        </label>
                        <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                            <span className="WebRupee">Rs.</span>
                            <span>
                                {utils.currencyFormat(lead.processingFees)}
                            </span>
                        </p>
                    </li>
                    <li className="mb-2 lg:mb-0">
                        <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                            Cheque/ECS Swapping Charge
                        </label>
                        <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                            <span className="WebRupee">Rs.</span>
                            <span>550</span> per instance
                        </p>
                    </li>
                    <li className="mb-0 lg:mb-0">
                        <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                            Cheque/SI/ECS Return Charges
                        </label>
                        <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                            <span className="WebRupee">Rs.</span>
                            <span>649</span> per instance
                        </p>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default SanctionCharges;
